import script from "./CsatPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./CsatPopup.vue?vue&type=script&setup=true&lang=js"

import "./CsatPopup.vue?vue&type=style&index=0&id=7d17a941&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d17a941"]])

export default __exports__